import {orderStatus} from "./config";

/**
 * 获得体检订单状态
 * @param status
 * @returns {*}
 */
export const filter_get_order_status = (status) => {
  if (!status) return '';
  return orderStatus[status] || status;
};
